<h1 mat-dialog-title>{{ data.modalTitle }}</h1>
<mat-dialog-content style="min-height: 34vh;">
  <div class="row" *ngIf="!properties.length">
    <div class="col-12">
      <p class="font-italic">
        {{ 'companies.detail.privacyDocsCard.generatePropertiesDialog.noProperties' | translate }}
      </p>
    </div>
  </div>
  <div class="row" *ngIf="properties.length">
    <div class="col-12 custom-label">
      <strong>{{ 'companies.detail.privacyDocsCard.generatePropertiesDialog.propertiesLabel' | translate }}</strong>
    </div>
    <div class="col-6">
      <mat-checkbox class="checkbox-insert" [checked]="selectAll" [disabled]="closeMappingInProgress"
        (change)="onSelectAll($event.checked)">
        {{ 'common.cta.selectAll' | translate }}
      </mat-checkbox>
    </div>
    <div class="col-6 text-right" *ngIf="openMappingProperties.length">
      <mat-checkbox class="checkbox-insert" [checked]="selectAllCloseMapping" [disabled]="closeMappingInProgress"
        (change)="onSelectAllCloseMapping($event.checked)">
        {{ 'companies.detail.privacyDocsCard.generatePropertiesDialog.selectAllOpenMappings' | translate }}
      </mat-checkbox>
    </div>
    <div class="col-12 properties-list">
      <div class="text-wrapper d-flex align-items-center justify-content-between" *ngFor="let item of properties">
        <mat-checkbox [(ngModel)]="item.value" [disabled]="item.mappingOpen || closeMappingInProgress"
          class="checkbox-insert property-checkbox">
          {{ item.name }}<span *ngIf="item.addressLabel"> - {{ item.addressLabel }}</span>
        </mat-checkbox>
        <span *ngIf="item.mappingOpen" class="d-flex align-items-center flex-shrink-0">
          <span class="mapping-open-label mr-2">
            {{ 'companies.detail.privacyDocsCard.generatePropertiesDialog.mappingOpenLabel' | translate }}
          </span>
          <mat-checkbox [(ngModel)]="item.closeMappingSelected" [disabled]="closeMappingInProgress"
            class="checkbox-insert close-mapping-checkbox">
            {{ 'companies.detail.privacyDocsCard.generatePropertiesDialog.closeMappingCheckboxLabel' | translate }}
          </mat-checkbox>
        </span>
      </div>
    </div>
  </div>
</mat-dialog-content>
<div class="row" mat-dialog-actions>
  <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
    <div class="d-flex align-items-center flex-wrap">
      <button mat-raised-button color="primary" [disabled]="!selectedCount || closeMappingInProgress"
        (click)="onSave()">
        {{ 'common.cta.save' | translate }}
      </button>
      <button mat-raised-button color="warn" class="ml-3" *ngIf="openMappingProperties.length"
        [disabled]="!closeMappingSelectedCount || closeMappingInProgress" (click)="onCloseMapping()">
        {{ 'companies.detail.privacyDocsCard.generatePropertiesDialog.closeMappingButton' | translate }}
      </button>
    </div>
    <button mat-raised-button [disabled]="closeMappingInProgress" (click)="onClose()">
      {{ 'common.cta.close' | translate }}
    </button>
  </div>
</div>
